import { render } from "./index.vue?vue&type=template&id=c67b7e10&scoped=true&bindings={}"
import script from "./Project.js?vue&type=script&lang=js"
export * from "./Project.js?vue&type=script&lang=js"

import "./Project.scss?vue&type=style&index=0&id=c67b7e10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c67b7e10"

export default script